
import React from 'react';

export default function Merits() {
  const merits = [
    {
      icon: 'ri-money-yen-circle-line',
      title: '条件達成で年会費実質無料',
      description:
        '22歳以下、年間30万円以上利用、またはドコモ料金プラン契約のいずれかで年会費3,300円が実質無料に。若者に優しい設計です。',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'ドコモ料金5%還元',
      description:
        'ドコモのケータイ・ドコモ光の利用料金1,000円（税抜）ごとに50ポイント還元。毎月の固定費でポイントがザクザク貯まります。',
    },
    {
      icon: 'ri-percent-line',
      title: 'ポイ活MAXで最大11%還元',
      description:
        'ドコモ ポイ活 MAXプラン契約で、いつものお買物が通常1%+キャンペーン10%の合計11%還元に。日常の買い物がお得に。',
    },
    {
      icon: 'ri-wifi-line',
      title: 'ahamo利用で毎月+5GB',
      description:
        'ahamoユーザーなら毎月のデータ量が+5GB増量。通常30GBが35GBに。データ量を気にせず使えます。',
    },
    {
      icon: 'ri-shield-check-line',
      title: 'ケータイ補償3年間最大10万円',
      description:
        '購入から3年間、紛失・盗難・修理不能時に同一機種の購入費用を最大10万円補償。万が一の時も安心です。',
    },
    {
      icon: 'ri-flight-takeoff-line',
      title: '空港ラウンジ無料＆旅行保険充実',
      description:
        '国内・ハワイの主要空港ラウンジが無料。海外旅行保険最高2,000万円、国内旅行保険最高1,000万円付帯。',
    },
  ];

  // Defensive rendering – ensure merits is an array
  if (!Array.isArray(merits) || merits.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-4">
          dカード GOLD Uのメリット
        </h2>
        <p className="text-center text-gray-600 mb-12">
          29歳以下限定の若者ファーストなゴールドカード
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {merits.map((merit, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-[#FFF5F5] to-white border border-[#FFE0E0] rounded-xl p-6 hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 bg-[#E60033] rounded-full flex items-center justify-center mb-4">
                <i className={`${merit.icon} text-2xl text-white`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg font-bold text-[#003366] mb-3">{merit.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{merit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
